import { actionTypes as ToastsActionTypes } from 'modules/toastContainer/actionTypes';
import { ActionTypes } from '../ducks/actionTypes';
import { MediumEnum } from './common';

export type GoalAnalyticsQuery = {
  includeRevenue: boolean;
  includePrevious: boolean;
  conversionEvent: string;
  startTime: string;
  endTime: string;
};

export enum GoalAnalyticsMetricKey {
  TOTAL_GOAL_CONVERSIONS = 'Total Goal Conversions',
  TOTAL_GOAL_CONVERSIONS_BY_TOTAL_MESSAGES_SENT = 'Total Goal Conversions / Total Messages Sent',
  TOTAL_SENT = 'Total Sent',
  UNIQUE_GOAL_CONVERSIONS = 'Unique Goal Conversions',
  UNIQUE_GOAL_CONVERSIONS_BY_UNIQUE_MESSAGES_SENT = 'Unique Goal Conversions / Unique Messages Sent',
  UNIQUE_SENT = 'Unique Sent',
  TOTAL_PURCHASES = 'Total Purchases',
  REVENUE = 'Goal Revenue',
}

export enum KeyofGoalAnalyticsMetricValue {
  MEDIUM = 'mediums',
  HISTOGRAM = 'histogram',
  VALUE = 'value',
}

export type HistogramValue = {
  buckets: {
    time: number;
    value: number;
  }[];
};

interface MetricValue {
  [KeyofGoalAnalyticsMetricValue.VALUE]: number;
  [KeyofGoalAnalyticsMetricValue.HISTOGRAM]?: HistogramValue;
}

export interface GoalAnalyticsMetricValue extends MetricValue {
  [KeyofGoalAnalyticsMetricValue.MEDIUM]: Record<MediumEnum, MetricValue>;
}

export type GoalAnalyticsMetricsData = Partial<
  Record<GoalAnalyticsMetricKey, GoalAnalyticsMetricValue>
>;

export type GoalAnalyticsData = {
  metrics: GoalAnalyticsMetricsData;
  previousMetrics?: GoalAnalyticsMetricsData;
};

export type GoalAnalyticsPayload = Record<string, unknown>;

export type GoalAnalyticsAction<T = Record<string, unknown>> = {
  type: ActionTypes | ToastsActionTypes;
  payload?: GoalAnalyticsPayload;
} & T;

export type GoalAnalyticsDataSelector =
  | [GoalAnalyticsMetricKey, KeyofGoalAnalyticsMetricValue]
  | [GoalAnalyticsMetricKey, KeyofGoalAnalyticsMetricValue, string];
